import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {SharedImports} from '@shared/shared-imports';
import {OrganizationRegistrationModel} from '@app/models/organizations.model';
import {SelfRegistrationModel} from '@app/models/user-registration.model';

@Component({
  selector: 'app-registration-page-5',
  templateUrl: './registration-page-5-confirm.component.html',
  styleUrls: ['./registration-page-5-confirm.component.scss'],
  imports: [
    SharedImports
  ]
})

export class RegistrationPage5ConfirmComponent implements OnInit {
  @Output() next = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Input() registrationProfile: SelfRegistrationModel;
  @Input() organizationDetails: OrganizationRegistrationModel;

  constructor(private router: Router, private location: Location) {

  }

  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);
  }

  goToNextPage() {
    this.next.emit();
  }

  login() {
    const baseUrl = window.location.href.replace(this.router.url, '');
    window.open(baseUrl + '/login', '_blank');
  }

  goBack() {
    this.location.back();
  }
}

